export default __webpack_public_path__ + "static/media/icon.military backpacks.c423bfc4.svg";